function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VAutocomplete, VListItem, VListItemTitle, VListItemContent } from 'vuetify/lib';
import template from './filter-select.html';
import FormMixin from '../form.mixin';
import SelectSearchSortMixin from '../../../../assets/scripts/mixins/select-search-sort.mixin'; // this will be checked against in preProcessFromData to force
// productValue to be "Other"

var OTHER_PRODUCT_ID = 'OTHER_PRODUCT_ID';

var FilterSelect = /*#__PURE__*/function () {
  function FilterSelect() {
    _classCallCheck(this, FilterSelect);
  }

  _createClass(FilterSelect, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-filter-select', {
        template: template,
        mixins: [FormMixin, SelectSearchSortMixin],
        props: {
          flaggedcountries: {
            type: Array,
            "default": function _default() {
              return [];
            }
          },
          fallbackOther: {
            type: Boolean,
            "default": false
          },
          labelNotFound: {
            type: String
          },
          labelOther: {
            type: String
          },
          returnObject: {
            type: Boolean,
            "default": false
          },
          promotedItemValue: {
            type: String
          }
        },
        data: function data() {
          return {
            /* eslint-disable no-nested-ternary */
            originalItems: this.$attrs.items ? this.fallbackOther ? [].concat(_toConsumableArray(this.$attrs.items), [{
              id: OTHER_PRODUCT_ID,
              label: this.labelOther
            }]) : this.$attrs.items : []
            /* eslint-enable no-nested-ternary */

          };
        },
        components: {
          VAutocomplete: VAutocomplete,
          VListItem: VListItem,
          VListItemTitle: VListItemTitle,
          VListItemContent: VListItemContent
        },
        computed: {
          otherValue: function otherValue() {
            return {
              id: OTHER_PRODUCT_ID,
              label: this.labelOther
            };
          },
          itemsWithPromoted: function itemsWithPromoted() {
            var _this = this;

            if (!this.promotedItemValue) {
              return this.sortedItems;
            }

            var promotedItemIndex = this.sortedItems.findIndex(function (item) {
              return item.value === _this.promotedItemValue;
            });

            if (promotedItemIndex === -1) {
              return this.sortedItems;
            }

            var promotedItemObject = this.sortedItems[promotedItemIndex];
            return [promotedItemObject].concat(_toConsumableArray(this.sortedItems));
          }
        },
        methods: {
          resetOnFocus: function resetOnFocus() {
            this.handleSearchInput();
            this.$refs.combobox.reset();
          },
          markedLabel: function markedLabel(label) {
            if (this.searchInput) {
              // find the first occurrence of the search input in the label
              var index = label.toLowerCase().indexOf(this.searchInput.toLowerCase()); // store the properly cased version of the search result

              var originalCaseSearchResult = label.substring(index, index + this.searchInput.length); // if found, mark the label

              if (index !== -1) {
                label = "".concat(label.substring(0, index), "<span class=\"v-list-item__mask\">").concat(originalCaseSearchResult, "</span>").concat(label.substring(index + this.searchInput.length));
              }
            }

            return "<span>".concat(label, "</span>");
          },
          selectOtherValue: function selectOtherValue() {
            this.$refs.combobox.selectItem(this.otherValue);
          }
        }
      });
    }
  }]);

  return FilterSelect;
}();

export default FilterSelect;